import { type TFunction } from 'i18next';
import { attemptErrorTranslation, capitalize } from './translation-utils';

interface Error {
  type: string;
  message: string;
}
export type ServerError<TData> = {
  [P in keyof TData]: Record<string, string>;
};

// Adapted from https://www.carlrippon.com/react-hook-form-server-validation/
export function setServerErrors<TData extends Record<string, unknown>>(
  errors: ServerError<TData>,
  setError: any,
  t: TFunction,
): void {
  console.warn(errors);
  return Object.keys(errors).forEach((key) => {
    let translations: string[] = [];
    const error = errors[key];
    if (
      'name' in error &&
      'detail' in error &&
      error.name === 'QueryFailedError'
    ) {
      translations = [attemptErrorTranslation('duplicate', error.detail, t)];
    }
    translations = Object.keys(error).map((constraint) => {
      const value = error[constraint];
      const translation = attemptErrorTranslation(constraint, value, t);
      return capitalize(translation);
    });

    setError(key as any, {
      type: 'server',
      message: translations.join('. '),
    });
  });
}
